/** TanStack Query hooks for §13's six concrete reports (`api/reports.api.js`). */
import { useQuery } from '@tanstack/react-query';
import * as reportsApi from '../../api/reports.api.js';
import { queryKeys } from '../../app/queryClient.js';

/** @param {object} [params] `{ breakdown, from, to, owner_id, territory_id }` */
export function useLeadsReport(params = {}) {
  return useQuery({ queryKey: queryKeys.reports.leads(params), queryFn: () => reportsApi.getLeadsReport(params) });
}

/** @param {object} [params] `{ breakdown, from, to, owner_id, territory_id }` */
export function useOpportunitiesReport(params = {}) {
  return useQuery({ queryKey: queryKeys.reports.opportunities(params), queryFn: () => reportsApi.getOpportunitiesReport(params) });
}

/** @param {object} [params] `{ breakdown, from, to, owner_id, kind }` */
export function useActivitiesReport(params = {}) {
  return useQuery({ queryKey: queryKeys.reports.activities(params), queryFn: () => reportsApi.getActivitiesReport(params) });
}

/** @param {object} [params] `{ breakdown, period, from, to, owner_id, territory_id }` */
export function useRevenueReport(params = {}) {
  return useQuery({ queryKey: queryKeys.reports.revenue(params), queryFn: () => reportsApi.getRevenueReport(params) });
}

/** @param {object} [params] `{ period }` */
export function useForecastReport(params = {}) {
  return useQuery({ queryKey: queryKeys.reports.forecast(params), queryFn: () => reportsApi.getForecastReport(params) });
}

/** @param {object} [params] `{ from, to }` */
export function useTerritoriesReport(params = {}) {
  return useQuery({ queryKey: queryKeys.reports.territories(params), queryFn: () => reportsApi.getTerritoriesReport(params) });
}
